import { calendarApi, CalendarApi } from "api/calendarApi";
import { useEffect, useState } from "react";

export const useCalendar = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<CalendarApi>();

  useEffect(() => {
    const fetchResource = async () => {
      const res = await calendarApi.fetch();
      try {
        setData(res.data);
      } catch (error) {
        // Handle error appropriately, perhaps with another state variable
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchResource();
  }, []);

  return { loading, data };
};
